(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["esim-product-v2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('esim-product-v2')) {
  customElements.define('esim-product-v2', class extends HTMLElement {
    connectedCallback() {
      const carrierDialog = this.querySelector('dialog[id^="esim-carrier-dialog-"]');
      const carrierOpen = this.querySelector('[data-carrier-modal-open]');
      const carrierClose = this.querySelector('[data-carrier-modal-close]');
      const carrierList = carrierDialog?.querySelector('ul');
      if (carrierList) {
        Array.from(carrierList.children)
          .sort((a, b) => a.textContent.trim().localeCompare(b.textContent.trim()))
          .forEach((item) => carrierList.appendChild(item));
        const names = [];
        carrierList.querySelectorAll('[data-carrier]').forEach((item) => {
          item.dataset.carrier.split(/[\\/,;]+/).map((name) => name.trim()).filter(Boolean).forEach((name) => {
            if (!names.some((existing) => existing.toLowerCase() === name.toLowerCase())) names.push(name);
          });
        });
        const summary = this.querySelector('[data-coverage-carrier-summary]');
        if (summary && names.length) summary.textContent = names.slice(0, 3).join(' · ') + (names.length > 3 ? ' + more' : '');
      }
      if (carrierDialog && carrierOpen) {
        carrierOpen.addEventListener('click', () => carrierDialog.showModal());
        carrierClose?.addEventListener('click', () => carrierDialog.close());
        carrierDialog.addEventListener('click', (event) => {
          if (event.target === carrierDialog) carrierDialog.close();
        });
      }
      const coverageDialog = this.querySelector('dialog[id^="esim-coverage-dialog-"]');
      const coverageOpens = this.querySelectorAll('[data-coverage-modal-open]');
      const coverageClose = this.querySelector('[data-coverage-modal-close]');
      const coverageList = coverageDialog?.querySelector('ul');
      if (coverageList) {
        Array.from(coverageList.children)
          .sort((a, b) => a.textContent.trim().localeCompare(b.textContent.trim()))
          .forEach((item) => coverageList.appendChild(item));
      }
      if (coverageDialog && coverageOpens.length) {
        coverageOpens.forEach((button) => button.addEventListener('click', () => coverageDialog.showModal()));
        coverageClose?.addEventListener('click', () => coverageDialog.close());
        coverageDialog.addEventListener('click', (event) => {
          if (event.target === coverageDialog) coverageDialog.close();
        });
      }
      this.variantScript = this.querySelector('[data-esim-variants]');
      if (!this.variantScript) return;

      try {
        this.variants = JSON.parse(this.variantScript.textContent);
      } catch (error) {
        return;
      }

      this.currency = this.dataset.currency || 'USD';
      this.variantInput = this.querySelector('[data-variant-id]');
      this.priceNodes = this.querySelectorAll('[data-selected-price]');
      this.summaryNodes = this.querySelectorAll('[data-selected-summary]');
      this.stickyPriceNodes = this.querySelectorAll('[data-sticky-price]');
      this.stickySummaryNodes = this.querySelectorAll('[data-sticky-summary]');
      this.dayButtons = Array.from(this.querySelectorAll('[data-day]'));
      this.planButtons = Array.from(this.querySelectorAll('[data-plan]'));
      this.hasServiceDays = this.dataset.hasServiceDays === 'true';
      this.buyButtons = Array.from(this.querySelectorAll('[data-buy-now], [data-buy-now-sticky]'));

      const dayContainer = this.querySelector('.esim-v2__days');
      if (dayContainer && this.dayButtons.length > 1) {
        this.dayButtons.sort((a, b) => {
          const aDays = parseInt(String(a.dataset.day || '').match(/\d+/)?.[0] || '0', 10);
          const bDays = parseInt(String(b.dataset.day || '').match(/\d+/)?.[0] || '0', 10);
          return aDays - bDays;
        });
        this.dayButtons.forEach((button) => dayContainer.appendChild(button));
      }

      const planContainer = this.querySelector('.esim-v2__plans');
      if (planContainer && this.planButtons.length > 1) {
        const planKey = (label) => {
          const text = String(label || '').toLowerCase();
          const unlimited = text.includes('unlimited');
          const total = text.includes('total');
          const daily = text.includes('/day') || text.includes('per day') || text.includes('daily');
          let group = unlimited ? 2 : total ? 1 : daily ? 0 : 1;
          const match = text.match(/(\d+(?:\.\d+)?)\s*(gb|mb)/i);
          let amount = 999999;
          if (match) amount = parseFloat(match[1]) * (match[2].toLowerCase() === 'gb' ? 1024 : 1);
          return [group, amount, text];
        };
        this.planButtons.sort((a, b) => {
          const ak = planKey(a.dataset.plan);
          const bk = planKey(b.dataset.plan);
          if (ak[0] !== bk[0]) return ak[0] - bk[0];
          if (ak[1] !== bk[1]) return ak[1] - bk[1];
          return ak[2].localeCompare(bk[2]);
        });
        this.planButtons.forEach((button) => planContainer.appendChild(button));
      }
      this.quantityInput = this.querySelector('[data-quantity-input]');
      this.quantityDisplay = this.querySelector('[data-quantity-display]');
      this.quantityMinus = this.querySelector('[data-quantity-minus]');
      this.quantityPlus = this.querySelector('[data-quantity-plus]');
      this.productForm = this.querySelector('form.esim-v2__form');
      this.cartButton = this.querySelector('.esim-v2__cart');
      this.installTabs = Array.from(this.querySelectorAll('[data-install-tab]'));
      this.installPanels = Array.from(this.querySelectorAll('[data-install-panel]'));
      this.fupNote = this.querySelector('[data-fup-note]');
      this.quantity = 1;

      const initialId = String(this.dataset.initialVariantId || '');
      const initialVariant = this.variants.find((variant) => String(variant.id) === initialId) || this.variants[0];

      this.selectedPlan = initialVariant && initialVariant.options ? initialVariant.options[0] : this.planButtons[0]?.dataset.plan;
      this.selectedDay = this.hasServiceDays && initialVariant && initialVariant.options && initialVariant.options.length > 1 ? initialVariant.options[1] : null;

      this.dayButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.hidden || button.disabled) return;
          this.selectedDay = button.dataset.day;
          this.refresh();
        });
      });

      this.planButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          this.selectedPlan = button.dataset.plan;
          this.refresh();
        });
      });

      this.buyButtons.forEach((button) => {
        button.addEventListener('click', () => this.buyNow(button));
      });

      this.installTabs.forEach((button) => {
        button.addEventListener('click', () => {
          const target = button.dataset.installTab;

          this.installTabs.forEach((tab) => {
            tab.setAttribute('aria-selected', tab.dataset.installTab === target ? 'true' : 'false');
          });

          this.installPanels.forEach((panel) => {
            const active = panel.dataset.installPanel === target;
            panel.hidden = !active;
            panel.classList.toggle('is-active', active);
          });
        });
      });

      if (this.productForm) {
        this.productForm.addEventListener('submit', (event) => {
          event.preventDefault();
          this.addToCart();
        });
      }

      if (this.quantityMinus) {
        this.quantityMinus.addEventListener('click', () => {
          this.quantity = Math.max(1, this.quantity - 1);
          this.updateQuantity();
        });
      }

      if (this.quantityPlus) {
        this.quantityPlus.addEventListener('click', () => {
          this.quantity += 1;
          this.updateQuantity();
        });
      }

      this.updateQuantity();
      this.refresh();
    }

    updateQuantity() {
      if (this.quantityInput) this.quantityInput.value = String(this.quantity);
      if (this.quantityDisplay) this.quantityDisplay.textContent = String(this.quantity);
    }

    findVariant(plan, day) {
      return this.variants.find((variant) => {
        if (!variant.options || !variant.options.length) return false;
        if (variant.options[0] !== plan) return false;
        if (!this.hasServiceDays) return true;
        return variant.options.length > 1 && variant.options[1] === day;
      });
    }

    variantIsAvailable(variant) {
      return Boolean(variant && variant.available !== false);
    }

    dayHasAvailableVariant(day) {
      if (!this.hasServiceDays) return true;
      return this.variants.some((variant) => {
        return variant.options &&
          variant.options.length > 1 &&
          variant.options[1] === day &&
          this.variantIsAvailable(variant);
      });
    }

    firstAvailableDay() {
      const button = this.dayButtons.find((dayButton) => this.dayHasAvailableVariant(dayButton.dataset.day));
      return button ? button.dataset.day : null;
    }

    formatMoney(cents) {
      const amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: this.currency,
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: 2
        }).format(amount);
      } catch (error) {
        return '$' + amount.toFixed(2);
      }
    }

    refresh() {
      if (this.hasServiceDays) {
        this.dayButtons.forEach((button) => {
          const dayAvailable = this.dayHasAvailableVariant(button.dataset.day);
          button.hidden = !dayAvailable;
          button.disabled = !dayAvailable;
          button.setAttribute('aria-hidden', dayAvailable ? 'false' : 'true');
        });

        if (!this.selectedDay || !this.dayHasAvailableVariant(this.selectedDay)) {
          this.selectedDay = this.firstAvailableDay();
        }
      }

      this.dayButtons.forEach((button) => {
        const active = !button.hidden && button.dataset.day === this.selectedDay;
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      let firstAvailablePlan = null;

      this.planButtons.forEach((button) => {
        const variant = this.findVariant(button.dataset.plan, this.selectedDay);
        const available = this.variantIsAvailable(variant);

        button.hidden = !available;
        button.disabled = !available;
        button.setAttribute('aria-hidden', available ? 'false' : 'true');

        const priceNode = button.querySelector('[data-plan-price]');
        if (priceNode) {
          priceNode.textContent = available ? this.formatMoney(variant.price) : '';
        }

        if (available && !firstAvailablePlan) {
          firstAvailablePlan = button.dataset.plan;
        }
      });

      let variant = this.findVariant(this.selectedPlan, this.selectedDay);
      const selectedPlanIsVisible = this.planButtons.some((button) => {
        return !button.hidden && button.dataset.plan === this.selectedPlan;
      });

      if (this.planButtons.length && (!selectedPlanIsVisible || !this.variantIsAvailable(variant))) {
        this.selectedPlan = firstAvailablePlan;
        variant = this.findVariant(this.selectedPlan, this.selectedDay);
      }

      this.planButtons.forEach((button) => {
        const active = !button.hidden && button.dataset.plan === this.selectedPlan;
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (!this.variantIsAvailable(variant)) return;

      if (this.variantInput) {
        this.variantInput.value = variant.id;
      }

      const price = this.formatMoney(variant.price);
      const summary = this.hasServiceDays ? this.selectedDay + ' · ' + this.selectedPlan : this.selectedPlan;

      this.priceNodes.forEach((node) => node.textContent = price);
      this.summaryNodes.forEach((node) => node.textContent = summary);
      this.stickyPriceNodes.forEach((node) => node.textContent = price);
      this.stickySummaryNodes.forEach((node) => node.textContent = summary);

      if (this.fupNote) {
        const planName = String(this.selectedPlan || '').toLowerCase();
        const productHandle = String(this.dataset.productHandle || '').toLowerCase();
        const titleNode = this.fupNote.querySelector('strong');
        const textNode = this.fupNote.querySelector('span');

        if (productHandle === 'japan-esim') {
          this.fupNote.hidden = false;

          if (planName.includes('unlimited')) {
            if (titleNode) titleNode.textContent = 'Japan unlimited plan:';
            if (textNode) textNode.textContent = 'Includes 2GB of high-speed data per day. After that, speed is reduced to up to 5 Mbps until the daily reset.';
          } else if (planName.includes('total')) {
            if (titleNode) titleNode.textContent = 'Japan total-data plan:';
            if (textNode) textNode.textContent = 'After the total high-speed data allowance is used, speed is reduced to 128 Kbps for the remaining validity period.';
          } else if (planName.includes('/day')) {
            if (titleNode) titleNode.textContent = 'Japan daily plan:';
            if (textNode) textNode.textContent = 'After the daily high-speed data allowance is used, speed is reduced to 128 Kbps until the next daily reset.';
          } else {
            this.fupNote.hidden = true;
          }
        } else {
          this.fupNote.hidden = !planName.includes('unlimited');
          if (!this.fupNote.hidden) {
            if (titleNode) titleNode.textContent = 'Unlimited plan:';
            if (textNode) textNode.textContent = '2GB high-speed data per day. After that, speeds are reduced to 5Mbps — enough for unlimited HD video streaming and everyday browsing.';
          }
        }
      }

      const variantText = String(variant.title || this.selectedPlan || '').toLowerCase();
      const hasCalls = variantText.includes('call') || variantText.includes('minute');
      const hasSms = variantText.includes('sms');
      this.querySelectorAll('[data-calls-status]').forEach((node) => {
        node.textContent = hasCalls ? '✓' : '✕';
        node.classList.toggle('is-yes', hasCalls);
        node.classList.toggle('is-no', !hasCalls);
      });
      this.querySelectorAll('[data-sms-status]').forEach((node) => {
        node.textContent = hasSms ? '✓' : '✕';
        node.classList.toggle('is-yes', hasSms);
        node.classList.toggle('is-no', !hasSms);
      });
      this.querySelectorAll('[data-plan-type]').forEach((node) => {
        node.textContent = hasCalls && hasSms ? 'Data + Calls + SMS' : hasCalls ? 'Data + Calls' : 'Data only';
      });
      this.querySelectorAll('[data-hotspot-label]').forEach((node) => {
        const defaultLabel = node.dataset.hotspotDefault || 'Supported';
        node.textContent = variantText.includes('hotspot') ? 'Included' : defaultLabel;
      });

      const available = variant.available !== false;
      this.buyButtons.forEach((button) => { button.disabled = !available; });
      if (this.cartButton) this.cartButton.disabled = !available;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((badge) => {
        badge.textContent = String(count);
        badge.hidden = count <= 0;
      });

      document.querySelectorAll('#cart-icon-bubble').forEach((cartIcon) => {
        let bubble = cartIcon.querySelector('.cart-count-bubble');

        if (count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
            cartIcon.appendChild(bubble);
          }

          const visibleCount = bubble.querySelector('[aria-hidden="true"]');
          const hiddenCount = bubble.querySelector('.visually-hidden');

          if (visibleCount) {
            visibleCount.textContent = count < 100 ? String(count) : '';
          }

          if (hiddenCount) {
            hiddenCount.textContent = count + (count === 1 ? ' item in cart' : ' items in cart');
          }
        } else if (bubble) {
          bubble.remove();
        }
      });
    }

    async addToCart() {
      const variantId = this.variantInput && this.variantInput.value;
      if (!variantId || !this.cartButton) return;

      const label = this.cartButton.querySelector('span');
      const originalLabel = label ? label.textContent : 'Add to cart';
      const cartDrawer = document.querySelector('cart-drawer');
      const requestBody = {
        items: [{
          id: Number(variantId),
          quantity: this.quantity || 1
        }]
      };

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        requestBody.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
        requestBody.sections_url = window.location.pathname;
      }

      this.cartButton.disabled = true;
      if (label) label.textContent = 'Adding…';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });

        const parsedState = await response.json();
        if (!response.ok) {
          throw new Error(parsedState.description || 'Unable to add item');
        }

        if (cartDrawer && parsedState.sections && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(parsedState);
        }

        const cartResponse = await fetch('/cart.js', {
          method: 'GET',
          headers: { 'Accept': 'application/json' },
          cache: 'no-store'
        });

        if (cartResponse.ok) {
          const cartState = await cartResponse.json();
          this.updateCartCount(Number(cartState.item_count || 0));
        }

        if (label) label.textContent = 'Added';
        window.setTimeout(() => {
          if (label) label.textContent = originalLabel;
          this.cartButton.disabled = false;
        }, 900);
      } catch (error) {
        if (label) label.textContent = 'Try again';
        this.cartButton.disabled = false;
        window.setTimeout(() => {
          if (label) label.textContent = originalLabel;
        }, 1600);
      }
    }

    async buyNow(button) {
      const variantId = this.variantInput && this.variantInput.value;
      if (!variantId) return;

      const originalText = button.textContent;
      this.buyButtons.forEach((item) => {
        item.disabled = true;
      });
      button.textContent = 'Opening checkout…';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: Number(variantId),
              quantity: this.quantity || 1
            }]
          })
        });

        if (!response.ok) {
          throw new Error('Unable to add item');
        }

        window.location.href = '/checkout';
      } catch (error) {
        button.textContent = 'Try again';
        this.buyButtons.forEach((item) => {
          item.disabled = false;
        });
        window.setTimeout(() => {
          button.textContent = originalText;
        }, 1800);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
